// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/AdditionalOptions/Content/AddNoteAction/Content/NotesInput/Content/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_AdditionalOptions_Content_AddNoteAction_Content_NotesInput_Content($organization_id: uuid!, $pattern: String!) {
  notes_templates(
    where: {
      organization_id: { _eq: $organization_id }
      name: { _ilike: $pattern }
      tags: { _contains: "appointment" }
    }
    order_by: { name: asc }
  ) {
    id
    value: url
    text: name
  }
}

`